import { 
  collection, 
  addDoc, 
  getDocs, 
  doc, 
  updateDoc, 
  deleteDoc, 
  query, 
  where, 
  orderBy,
  Timestamp 
} from 'firebase/firestore';
import { db } from '../lib/firebase';
import { Exercise, ExerciseFormData } from '../types/exercise';

const COLLECTION_NAME = 'c3_exercises';

export const exerciseService = {
  // Create a new exercise
  async createExercise(exerciseData: ExerciseFormData, userId: string, userEmail: string): Promise<string> {
    const now = Timestamp.now();
    
    const exercise = {
      ...exerciseData,
      ownerUid: userId,
      createdByEmail: userEmail,
      status: 'Planned' as const,
      injects: exerciseData.injects.map((inject, index) => ({
        ...inject,
        id: `inject_${index + 1}`
      })),
      createdAt: now,
      updatedAt: now
    };

    const docRef = await addDoc(collection(db, COLLECTION_NAME), exercise);
    return docRef.id;
  },

  // Get all exercises for a user
  async getUserExercises(userId: string): Promise<Exercise[]> {
    const q = query(
      collection(db, COLLECTION_NAME),
      where('ownerUid', '==', userId),
      orderBy('createdAt', 'desc')
    );
    
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    } as Exercise));
  },

  // Update an exercise
  async updateExercise(exerciseId: string, exerciseData: Partial<ExerciseFormData>): Promise<void> {
    const exerciseRef = doc(db, COLLECTION_NAME, exerciseId);
    await updateDoc(exerciseRef, {
      ...exerciseData,
      updatedAt: Timestamp.now()
    });
  },

  // Delete an exercise
  async deleteExercise(exerciseId: string): Promise<void> {
    const exerciseRef = doc(db, COLLECTION_NAME, exerciseId);
    await deleteDoc(exerciseRef);
  },

  // Update exercise status
  async updateExerciseStatus(exerciseId: string, status: Exercise['status']): Promise<void> {
    const exerciseRef = doc(db, COLLECTION_NAME, exerciseId);
    await updateDoc(exerciseRef, {
      status,
      updatedAt: Timestamp.now()
    });
  }
};

